import React from 'react'
import { observer } from 'mobx-react'
import styled from 'styled-components'

import { tabletSize, mobileSize } from 'theme'
import { useUserAgentStore } from 'store/userAgentStore'
import { useUserStore } from 'store/userStore'
import { hidden } from './mixin'
import MobileCouponHeader from './MobileCouponHeader'
import Logo from './Logo'
import Tabs from './Tabs'
import SearchInput from './SearchInput'
import Login from './Login'
import CategoryBar from './CategoryBar'
import useBreakpoint from 'hooks/useBreakpoint'

const CouponHeader = observer(({ pathname }) => {
  const userAgentStore = useUserAgentStore()
  const isMobile = userAgentStore.isMoblie()
  const isInAppWebView = userAgentStore.isInAppWebView()
  const { isLoggedIn } = useUserStore()
  const { matchesM } = useBreakpoint()

  const showCategoryBar =
    pathname === '/skus' || (pathname === '/mycoupon' && isLoggedIn)
  if (isMobile || matchesM) {
    return <MobileCouponHeader isInAppWebView={isInAppWebView} />
  }

  return (
    <>
      <HeaderWrapper>
        <HeaderInner>
          <HeaderLeft>
            <Logo />
            <Tabs currentPathname={pathname} />
          </HeaderLeft>
          <HeaderRight>
            <SearchInput />
            <Divider />
            <Login />
          </HeaderRight>
        </HeaderInner>
      </HeaderWrapper>
      {showCategoryBar && <CategoryBar />}
    </>
  )
})

const HeaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  background-color: ${(p) => p.theme.color.white};
  box-shadow: 0 2px 23px 0 #e4e6e9;
  z-index: 10;
  position: sticky;
  top: 0;
`

const HeaderInner = styled.div`
  display: flex;
  height: 64px;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: ${(p) => p.theme.desktopMaxWidth};
  padding: 0 24px;
  box-sizing: border-box;

  @media ${tabletSize} {
    padding: 0 16px;
  }

  @media ${mobileSize} {
    padding: 0 12px;
  }
`

const HeaderLeft = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  margin-right: 32px;
`

const HeaderRight = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
`

const Divider = styled.div`
  width: 1px;
  height: 24px;
  background-color: ${(p) => p.theme.color.grey100};
  margin: 0 16px;

  @media ${tabletSize} {
    ${hidden};
  }
`

export default CouponHeader
